import React from 'react';

export function Success() {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 23.9905C18.6274 23.9905 24 18.6179 24 11.9905C24 5.36306 18.6274 -0.00952148 12 -0.00952148C5.37258 -0.00952148 0 5.36306 0 11.9905C0 18.6179 5.37258 23.9905 12 23.9905ZM16.4101 7.5077L10.2001 13.7178L7.29002 10.8077C7.09476 10.6124 6.77817 10.6124 6.58291 10.8077L6.01723 11.3734C5.82196 11.5687 5.82196 11.8852 6.01723 12.0805L10.2001 16.2633L17.6829 8.7805C17.8782 8.58523 17.8782 8.26865 17.6829 8.07339L17.1172 7.5077C16.922 7.31244 16.6054 7.31244 16.4101 7.5077Z"
				fill="#149EF2"
			/>
		</svg>
	);
}
